import { render, staticRenderFns } from "./PopUpDocs.vue?vue&type=template&id=030c2d2e"
import script from "./PopUpDocs.vue?vue&type=script&lang=js"
export * from "./PopUpDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports